import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function LinksTocIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 78, width: 62 }}
      viewBox="0 0 62 78"
    >
      <g fill="none" fillRule="evenodd">
        <rect
          data-toc-card=""
          fill="#FFF"
          height="77"
          rx="3"
          stroke={IconColors.Grey}
          width="61"
          x=".5"
          y=".5"
        />
        <g fill={IconColors.DarkBlue}>
          <rect height="4" rx="2" width="27" x="8" y="14" />
          <rect height="4" rx="2" width="22" x="8" y="28" />
          <rect height="4" rx="2" width="18" x="8" y="42" />
        </g>
        <rect fill={IconColors.Grey} height="3" rx="1.5" width="46" x="8" y="66" />
      </g>
    </SvgIcon>
  );
}
